module.exports = __webpack_public_path__ + "img/used2.385b804e.png";